import React, { useState, useEffect } from 'react';
import {
  SearchInput,
  INPUT_SIZES,
  Loader,
  Toast,
  TOAST_POSITIONS,
  TOAST_VARIANTS,
  TOAST_VISIBILITY_DURATIONS,
} from 'cdk-radial';
import './ReviewAndRemoveAPIs.scss';
import { useSelector, useDispatch } from 'react-redux';
import OrderAPIStepperFooter from '../StepperFooter/OrderAPIStepperFooter';
import {
  deleteApiDetails,
  updateAPIPricingPlanId,
  resetAddingPricingPlanToApiInCart,
} from '../../../../../redux/connectedComponent/orderAPI/orderAPI.slice';
import { Card } from 'cdk-radial';
import { Button, IconArrowForward } from 'cdk-radial';
import {
  AMPLITUDE_EVENTS,
  AMPLITUDE_PROPERTIES,
} from '../../../../../constants/amplitudeConstants';
import {
  getOrgAmplitudeProperties,
  sendAmplitudeData,
} from '../../../../../utils/amplitude';
import {
  getPlanName,
  getPlansToShowForAPI,
  getPlanType,
  getSelctedPlanOfAPI,
  parsePrice,
  API_PLANS_MODAL_TITLE,
  PLAN_TYPE,
  formatCurrency,
} from '../../../utils/apiPricingUtil';
import { ORDER_APIS_STEPPER_FOOTER } from '../../../../../constants/APIDirectoryConstants';
import { APIPricingPlansModal } from '../../../Common/APIPricingPlansModal/APIPricingPlansModal';
import { trackRemoveFromCart, trackSelectApiPlan, trackSelectBundlePlan } from '../../../../../utils/gtm';
import { Constants, RESOURCE_TYPES } from '../../../../../constants/constants';
import { getAPIDetailsById } from '../../../../../redux/connectedComponent/apiDirectory/apiDirectory.slice';

const FAILURE_MSG = 'Failed to update the pricing plan. Try again after sometime.';

const PriceValueComponent = ({
  dealerDirPlanPrice,
  showTnC,
  selectedResourceWithPlan,
  isBundle = false,
  isSummary = false,
}) => {
  const selectedResourceWithPlanValues = Object.values(
    selectedResourceWithPlan
  );
  const isAllPlansTypeSubscription =
    selectedResourceWithPlanValues.length > 0 &&
    Array.isArray(selectedResourceWithPlanValues) &&
    selectedResourceWithPlanValues.every(
      (f) => f.type && f.type.toLocaleLowerCase() === PLAN_TYPE.SUBSCRIPTION
    );

  // Determine the pricing text based on plan type and if it's a bundle
  const getPricingText = () => {
    const isSubscription =
      (selectedResourceWithPlan?.type &&
        selectedResourceWithPlan?.type.toLocaleLowerCase() ===
          PLAN_TYPE.SUBSCRIPTION) ||
      isAllPlansTypeSubscription;

    if (isBundle || isSubscription) {
      return `location per month${showTnC ? ' *' : ''}`;
    }

    return isSummary
      ? `per month${showTnC ? ' *' : ''}`
      : `month${showTnC ? ' *' : ''}`;
  };

  const pricingText = getPricingText();

  // Determine class names based on context (summary vs review item)
  const isSubscriptionType =
    (selectedResourceWithPlan?.type &&
      selectedResourceWithPlan?.type.toLocaleLowerCase() ===
        PLAN_TYPE.SUBSCRIPTION) ||
    isAllPlansTypeSubscription ||
    isBundle;

  const containerClass = isSummary
    ? isSubscriptionType
      ? 'api-summary-item-subscription-plan-value'
      : 'api-summary-item-plan-value'
    : isSubscriptionType
    ? 'api-review-item-subscription-plan-value'
    : 'api-review-item-plan-value';

  const amountClass = isSummary
    ? 'api-summary-item-plan-ammount'
    : 'api-review-item-plan-ammount';
  const textClass = isSummary
    ? 'api-summary-item-plan-text'
    : 'api-review-item-plan-text';

  return (
    <div className={containerClass}>
      <span className={amountClass}>
        {`$${new Intl.NumberFormat('en-US').format(dealerDirPlanPrice)}`}
      </span>
      <span className={textClass}>{`/${pricingText}`}</span>
    </div>
  );
};

const ReviewAndRemoveAPIs = ({ setActiveStep, activeStep, cart = [] }) => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const [searchInputValue, setSearchInputValue] = useState('');
  const fortellisEnterpriseEntityId =
    state?.loginDetailsSlice?.fortellisEnterpriseEntityId;
  const {
    requestedAPIsToRemoveFromCart,
    fetchingCartDetails,
    errorAddingPricingPlanToApiInCart,
    successAddingPricingPlanToApiInCart,
  } = state?.orderAPISlice;
  const token = state?.loginDetailsSlice?.authenticationToken;
  const [searchResults, setSearchResults] = useState([]);
  const [selectedResourceWithPlan, setSelectedResourceWithPlan] = useState({});
  const [resourceInCart, setResourceInCart] = useState({
    isPriceBundleExist: false,
    isApiExist: false
  })
  const [totalBill, setTotalBill] = useState(0)
  const [totalBundleBill, setTotalBundleBill] = useState(0);
  const [totalInstallFee, setTotalInstallFee] = useState(0);
  const [hasInstallFee, setHasInstallFee] = useState(false);
  const [isContinueDisabled, setIsContinueDisabled] = useState(true);
  const [selectedAPI, setSelectedAPI] = useState();
  const [isPricingPlanDialogOpen, setIsPricingPlanDialogOpen] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastVriant, setToastVariant] = useState(TOAST_VARIANTS.POSITIVE);
  const [toastContent, setToastContent] = useState('');
  const { apiInfo, bundles } = state?.apiDirectorySlice;
  useEffect(() => {
    const apiName = selectedAPI?.details?.name;
    if (successAddingPricingPlanToApiInCart) {
      closePricingPlansDialog();
      dispatch(resetAddingPricingPlanToApiInCart());
    } else if (errorAddingPricingPlanToApiInCart) {
      closePricingPlansDialog();
      setToastContent(FAILURE_MSG);
      setToastVariant(TOAST_VARIANTS.NEGATIVE);
      setShowToast(true);
      dispatch(resetAddingPricingPlanToApiInCart());
    }
  }, [errorAddingPricingPlanToApiInCart, successAddingPricingPlanToApiInCart]);
  const orgAmplitudeProperties = getOrgAmplitudeProperties(
    state?.loginDetailsSlice
  );
  useEffect(() => {
    setSearchResults(
      cart?.filter((a) =>
        a?.details?.name
          ?.toLowerCase()
          .includes(searchInputValue?.toLowerCase())
      )
    );
    let totalFee = 0; // api fee
    let totalBundleFee = 0; // bundle fee
    let totalInstallFeeAmount = 0;
    let hasAnyInstallFee = false;
    let selectedResources = cart?.reduce((prev, resource) => {
      let plan = getSelctedPlanOfAPI(resource);
      let plansToshow = getPlansToShowForAPI(resource?.details.plans);

      if (plan && plansToshow?.filter((plnsToshow) => plnsToshow.id === plan.id).length > 0) {
        const isBundle = resource.resourceType === RESOURCE_TYPES.BUNDLE;
        
        prev[resource.resourceId] = {...plan};
        prev[resource.resourceId].dealerDirPlanDisplayName = getPlanName(getPlanType(plan), isBundle, plan?.name)
        prev[resource.resourceId].dealerDirPlanPrice = parsePrice(plan)
        prev[resource.resourceId].dealerDirInstallFee = plan?.installFee ?? null
        prev[resource.resourceId].isDealerPlan = plan?.isDealerPlan ?? false
        //Calculate fee
        if(isBundle) {
          totalBundleFee = totalBundleFee + parsePrice(plan)
        } else {
          totalFee = totalFee + parsePrice(plan)
        }
        // Check if install fee should be shown
        const shouldShowInstallFee = (resource.resourceType === RESOURCE_TYPES.BUNDLE || plan?.isDealerPlan) && plan?.installFee != null;
        if (shouldShowInstallFee) {
          hasAnyInstallFee = true;
          totalInstallFeeAmount = totalInstallFeeAmount + plan.installFee;
        }
      }
      return prev
    }, {})
    setTotalBill(totalFee)
    setResourceInCart({
      isApiExist: cart.find((item) => item.resourceType === 'api' || item.resourceType === 'async-api'),
      isPriceBundleExist: cart.find((item) => item.resourceType === RESOURCE_TYPES.BUNDLE)
    })
    setTotalBundleBill(totalBundleFee)
    setTotalInstallFee(totalInstallFeeAmount)
    setHasInstallFee(hasAnyInstallFee)
    setSelectedResourceWithPlan(
      selectedResources
    )
    setIsContinueDisabled(Object.keys(selectedResources).length === cart.length ? false : true)

  }, [cart]);

  const buttonClickHandler = (redirectUrl) => {
    if (redirectUrl === 'api-directory')
      sendAmplitudeData(AMPLITUDE_EVENTS.START_API_BUYER_FLOW, {});
    const url = window.location.href.split('/checkout')[0];
    localStorage.setItem('dplocationWithoutApp', `${url}/${redirectUrl}`);
    window.location.assign(localStorage.getItem('dplocationWithoutApp'));
  };

  const handleAPIDeleteFromCart = async (apiToBeDeleted) => {
    const resourceId = apiToBeDeleted?.resourceId;
    try {
      await dispatch(
        deleteApiDetails({ entityId: fortellisEnterpriseEntityId, token, resourceIds: resourceId })
      ).unwrap();
      
      // Only track on successful deletion
      trackRemoveFromCart(apiToBeDeleted, cart);
      sendAmplitudeData(
        AMPLITUDE_EVENTS.REMOVE_FROM_CART,
        orgAmplitudeProperties
      );
    } catch (error) {
      // Error is handled by Redux and tracked in OrderAPIStepper
    }
  };

  const handleSearchInputChange = (searchInput) => {
    setSearchInputValue(searchInput);
    setSearchResults(
      cart?.filter((a) =>
        a?.details?.name?.toLowerCase().includes(searchInput.toLowerCase())
      )
    );
  };

  const openPricingPlansDialog = (resource) => {
    if (resource.resourceType === RESOURCE_TYPES.BUNDLE) {
      // Find the bundle details from the bundles array
      const bundleDetails = bundles?.find(
        (bundle) => bundle.id === resource.resourceId
      );

      if (bundleDetails) {
        // Create a bundle object similar to API structure for consistency
        const bundleWithDetails = {
          ...resource,
          details: {
            ...resource.details,
            plans: bundleDetails.plans || resource.details?.plans || [],
            name: bundleDetails.name || resource.details?.name,
          },
        };
        setSelectedAPI(bundleWithDetails);
        setIsPricingPlanDialogOpen(true);
      } else {
        // Fallback if bundle details not found
        console.warn('Bundle details not found in bundles array');
        setSelectedAPI(resource);
        setIsPricingPlanDialogOpen(true);
      }
    } else {
      dispatch(
        getAPIDetailsById({
          apiId: resource.resourceId,
          apiType: resource.apiType,
          token,
        })
      );
      setSelectedAPI(resource || apiInfo);
      setIsPricingPlanDialogOpen(true);
      if (selectedResourceWithPlan?.[resource.resourceId]) {
        sendAmplitudeData(
          AMPLITUDE_EVENTS.REVIEW_CART_EDIT_PLAN,
          orgAmplitudeProperties
        );
      } else {
        sendAmplitudeData(
          AMPLITUDE_EVENTS.REVIEW_CART_SELECT_PLAN,
          orgAmplitudeProperties
        );
      }
    }
  };

  const closePricingPlansDialog = () => {
    setIsPricingPlanDialogOpen(false);
  };

  const handlePricingPlanSelect = (payload) => {
    const apiCartItem =
      Array.isArray(cart) && cart.find((api) => api.resourceId === payload?.resourceId);
    if (apiCartItem) {
      const selectedMatchedPlan = selectedAPI?.details?.plans?.find(
        (plan) => plan?.id === payload?.resourcePricingPlanId,
      );
      const planName = selectedMatchedPlan?.name || payload?.planName || payload?.resourcePricingPlanId;
      if (selectedAPI?.resourceType === RESOURCE_TYPES.BUNDLE) {
        trackSelectBundlePlan(planName, payload?.resourceId, selectedAPI?.details?.name || payload?.Name);
      } else {
        trackSelectApiPlan(planName, payload?.resourceId, selectedAPI?.details?.name || payload?.Name, selectedAPI?.resourceType || payload?.resourceType);
      }

      sendAmplitudeData(AMPLITUDE_EVENTS.REVIEW_CART_UPDATE_PRICING_PLAN_OF_API, {
          [AMPLITUDE_PROPERTIES.APIS]: {
            [AMPLITUDE_PROPERTIES.RESOURCE_NAME]: payload?.Name || '',
            [AMPLITUDE_PROPERTIES.RESOURCE_ID]: payload?.resourceId || '',
            [AMPLITUDE_PROPERTIES.RESOURCE_TYPE]: payload?.resourceType || '',
          },
      });
      const data = {
        resourceId: payload?.resourceId,
        resourcePricingPlanId: payload?.resourcePricingPlanId || '',
      };
      payload = { ...data };
      dispatch(updateAPIPricingPlanId({ payload, token }));
    }
  };

  useEffect(() => {
      const paginatedResults = cart
        ?.filter((a) =>
      a?.details?.name?.toLowerCase().includes(searchInputValue.toLowerCase())
        )
    setSearchResults(paginatedResults);
  }, [searchInputValue, cart]);

  const monthlySubscriptionPerLocation = totalBundleBill + totalBill;
  const estimatedTotal = monthlySubscriptionPerLocation + totalInstallFee;
  const estimatedMonthlyTotal = monthlySubscriptionPerLocation;

  return (
    <>
      <Card className="review-and-confirm-section">
        {/*When we do have api cart*/}
        {cart?.length > 0 && (
          <div className="review-apis-container">
            <span className="api-review-cart-title">
              {Constants.API_REVIEW_CART}
            </span>
            <div className="api-review-search-div">
              <div className="api-review-cart-description">
                {Constants.REVIEW_OR_REMOVE_APIS}
              </div>
              <div className="cart-api-search">
                <SearchInput
                  clearButtonLabel="clearButtonLabel"
                  id="search-input-expanded"
                  isAlwaysExpanded
                  name="search-input-expanded"
                  onChange={handleSearchInputChange}
                  placeholder="Search"
                  size={INPUT_SIZES.SMALL}
                  value={searchInputValue}
                />
              </div>
            </div>

            {fetchingCartDetails ? (
              <Loader
                label="fetching cart info..."
                className="order-api-loader"
              />
            ) : (
              <>
                <div className="api-review-list">
                  {searchResults.map((element, index) => {
                    const plansToShow = getPlansToShowForAPI(
                      element?.details?.plans
                    );
                    const selectedPlan = selectedResourceWithPlan?.[element.resourceId];
                    const hasPlanSelected = !!selectedPlan;
                    const hasPlans = plansToShow && plansToShow.length > 0;
                    const hasMultiplePlans = plansToShow && plansToShow.length > 1;
                    const shouldShowInstallFee =
                      (element.resourceType === RESOURCE_TYPES.BUNDLE || selectedPlan?.isDealerPlan) &&
                      selectedPlan?.dealerDirInstallFee != null;

                    return (
                      <li
                        key={index}
                        className={`api-review-item${shouldShowInstallFee ? ' api-review-item--with-install-fee' : ''}`}
                      >
                        <div className="api-review-item-top">
                          <div className="api-details">
                            <div className="api-text">
                              <div className="api-review-item-main-content">
                                <span
                                  className="api-review-item-title"
                                  role="list-api"
                                >
                                  {element?.details?.name}{' '}
                                  {element.resourceType === RESOURCE_TYPES.BUNDLE && (
                                    <span className="api-review-item-title-suffix">
                                      - Bundle
                                    </span>
                                  )}
                                </span>
                                {requestedAPIsToRemoveFromCart?.includes(
                                  element.resourceId
                                ) ? (
                                  <Loader
                                    className="api-review-item-remove-loader"
                                    label="Removing from cart ... "
                                  />
                                ) : (
                                  <span
                                    className="api-review-item-button"
                                    onClick={() => handleAPIDeleteFromCart(element)}
                                  >
                                    {'Remove from Cart'}
                                  </span>
                                )}
                              </div>
                            </div>
                            {(hasPlanSelected || hasPlans) && (
                              <div
                                className={
                                  selectedPlan?.dealerDirPlanDisplayName
                                    ?.toLocaleLowerCase() ===
                                  PLAN_TYPE.SUBSCRIPTION ||
                                  selectedPlan?.plan?.toLocaleLowerCase() === PLAN_TYPE.DEALER ||
                                  selectedPlan?.type?.toLocaleLowerCase() === PLAN_TYPE.SUBSCRIPTION
                                    ? 'api-review-item-subscription-plan'
                                    : 'api-review-item-plan'
                                }
                              >
                                {selectedPlan && (
                                <span className="api-review-item-title">
                                  {selectedPlan
                                    ?.dealerDirPlanDisplayName
                                    ? `${
                                        selectedPlan
                                          ?.dealerDirPlanDisplayName
                                      }${selectedPlan?.dealerDirPlanDisplayName
                                        ?.toLocaleLowerCase()
                                        ?.endsWith('plan')
                                        ? ''
                                        : ' Plan'}`
                                    : ''}
                                </span>
                                )}
                                {((hasPlanSelected && hasMultiplePlans) || (!hasPlanSelected && hasPlans)) && (
                                  <span
                                    className={`api-review-item-button`}
                                    onClick={() =>
                                      openPricingPlansDialog(element)
                                    }
                                  >
                                    {hasPlanSelected ? 'Edit Plan' : 'Select Plan'}
                                  </span>
                                )}
                              </div>
                            )}
                            {selectedPlan ? (
                              <PriceValueComponent
                                dealerDirPlanPrice={
                                  selectedPlan?.dealerDirPlanPrice
                                }
                                showTnC={true}
                                selectedResourceWithPlan={selectedPlan}
                                isBundle={element.resourceType === RESOURCE_TYPES.BUNDLE}
                              />
                            ) : (
                              <div className="api-review-item-plan-value" />
                            )}
                          </div>
                        </div>
                        {shouldShowInstallFee && (
                          <div className="api-review-item-install-fee">
                            <span className="api-review-item-install-fee-label">Install Fee</span>
                            <span className="api-review-item-install-fee-value">
                              {formatCurrency(selectedPlan?.dealerDirInstallFee)}
                            </span>
                          </div>
                        )}
                      </li>
                    );
                  })}
                </div>

                <div className="api-review-summary">
                  <div className="api-review-summary-title">Order Summary</div>
                  {hasInstallFee ? (
                    <>
                      <div
                        className="api-review-summary-total api-review-summary-total--no-divider api-review-summary-total--compact-bottom"
                        style={{ borderTop: 'none' }}
                      >
                        <div className="api-review-item-title-install-fee">
                          Monthly Subscription Fee per Location
                        </div>
                        <div className="api-summary-item-plan-value">
                          <span className="api-summary-item-plan-ammount">
                            {formatCurrency(monthlySubscriptionPerLocation)}
                          </span>
                          <span className="api-summary-item-plan-text">/month *</span>
                        </div>
                      </div>
                      <div className="api-review-summary-total api-review-summary-total--compact-top">
                        <div className="api-review-item-title-install-fee">
                          Total Install Fee
                          <span className="api-review-summary-inline-note"> (One Time Fee)</span>
                        </div>
                        <div className="api-summary-item-plan-value">
                          <span className="api-summary-item-plan-ammount">
                            {formatCurrency(totalInstallFee)}
                          </span>
                        </div>
                      </div>
                      <div className="api-review-summary-total">
                        <div className="api-review-item-title">
                          Estimated Total
                          <div className="api-review-summar-sub-fee-des">
                            One time Install Fee + Monthly Fees per Location
                          </div>
                        </div>
                        <div className="api-summary-item-plan-value">
                          <span className="api-summary-item-plan-ammount-install-fee">
                            {formatCurrency(estimatedTotal)}
                          </span>
                        </div>
                      </div>
                      <div className="api-review-summary-total">
                        <div className="api-review-item-title">
                          Estimated Monthly Total
                          <div className="api-review-summar-sub-fee-des">
                            *Does not include overage, usage fees or taxes.
                          </div>
                        </div>
                        <div className="api-summary-item-plan-value">
                          <span className="api-summary-item-plan-ammount-install-fee">
                            {formatCurrency(estimatedMonthlyTotal)}
                          </span>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      {resourceInCart.isPriceBundleExist && (
                        <div
                          className="api-review-summary-total"
                          style={{ borderTop: 'none' }}
                        >
                          <div className="api-review-item-title">
                            Estimated Bundle Total
                            <div className="api-review-summar-sub-fee-des">
                              *Estimate is for a single location and does not
                              include taxes.
                            </div>
                          </div>
                          <PriceValueComponent
                            dealerDirPlanPrice={totalBundleBill}
                            selectedResourceWithPlan={selectedResourceWithPlan}
                            isBundle={true}
                            isSummary={true}
                          />
                        </div>
                      )}
                      {resourceInCart.isApiExist && (<div className="api-review-summary-total">
                        <div className="api-review-item-title">
                          Estimated Total
                          <div className="api-review-summar-sub-fee-des">
                            *Does not include overage, usage fees or taxes.
                          </div>
                        </div>
                        <PriceValueComponent
                          dealerDirPlanPrice={totalBill}
                          selectedResourceWithPlan={selectedResourceWithPlan}
                          isSummary={true}
                        />
                      </div>)}
                    </>
                  )}
                </div>
              </>
            )}
            <OrderAPIStepperFooter
              setActiveStep={setActiveStep}
              activeStep={activeStep}
              step={ORDER_APIS_STEPPER_FOOTER.REVIEW_APIS}
              isContinueDisabled={
                requestedAPIsToRemoveFromCart?.length > 0 || isContinueDisabled
              }
              cart={cart}
            />
          </div>
        )}

        {/*When we do not have api cart*/}
        {cart?.length === 0 && (
          <div className="empty-cart-section">
            <div className="review-apis-container">
              <span className="api-review-cart-title">
                {Constants.API_REVIEW_CART}
              </span>
              <div className="api-review-cart-description">
                There are no APIs added into your API Integrations.
              </div>
              <Button
                dataTestId="button"
                icon={<IconArrowForward />}
                isIconTrailing
                iconColor="gray"
                iconSize={24}
                onClick={() => buttonClickHandler('api-directory')}
                size="standard"
                text="Browse the API Directory"
                variant="primary"
              />
            </div>
          </div>
        )}
      </Card>
      {isPricingPlanDialogOpen && (
        <APIPricingPlansModal
          isOpen={isPricingPlanDialogOpen}
          selectedAPI={selectedAPI}
          title={
            selectedResourceWithPlan?.[selectedAPI.resourceId]
              ? API_PLANS_MODAL_TITLE.PLAN_SELECTED
              : API_PLANS_MODAL_TITLE.NO_PLAN_SELECTED
          }
          onClose={closePricingPlansDialog}
          onAccept={handlePricingPlanSelect}
        />
      )}
      {showToast && (
        <Toast
          variant={toastVriant}
          content={toastContent}
          id="pricing-plan-update-toast"
          actions={[
            {
              onClick: () => {
                setShowToast(false);
              },
              text: 'Dismiss',
            },
          ]}
          onVisibilityDurationEnd={() => {
            setShowToast(false);
          }}
          position={TOAST_POSITIONS.FIXED}
          visibilityDuration={TOAST_VISIBILITY_DURATIONS.SIX_SECONDS}
          style={{ marginTop: '64px' }}
        />
      )}
    </>
  );
};
export default ReviewAndRemoveAPIs;
